import * as BFConfig from './skins/BF/config';
import * as SNConfig from './skins/SN/config';
import * as MTConfig from './skins/MT/config';

const configs = {
  BF: BFConfig,
  SN: SNConfig,
  MT: MTConfig,
};

const siteCode = process.env.REACT_APP_SITE_CODE;

if (!configs[siteCode]) {
  throw new Error(`Unsupported site code: ${siteCode}`);
}

const { config, contentRoutes, footerLinks, urls, HeaderLinks } = configs[siteCode];

const timestamp = Date.now();
const images = {
  logoDark: `/${siteCode}/logo-dark.svg?v=${timestamp}`,
  logoLight: `/${siteCode}/logo-light.svg?v=${timestamp}`,
};

export { config, contentRoutes, footerLinks, images, urls, HeaderLinks };
